export interface DocPopupMenuItem {
  label?: string;
  /** Optional secondary line when this entry is rendered as a section header. */
  subtitle?: string;
  icon?: string;
  command?: (event?: any) => void;
  disabled?: boolean;
  separator?: boolean;
  visible?: boolean;
  escape?: boolean;
  styleClass?: string;
  items?: DocPopupMenuItem[];
}

export type DocPopupMenuFlatEntry =
  | { kind: 'separator'; id: string }
  | { kind: 'header'; id: string; label: string; subtitle?: string }
  | { kind: 'item'; id: string; item: DocPopupMenuItem };

export function flattenDocPopupMenuItems(items: DocPopupMenuItem[] | null | undefined): DocPopupMenuFlatEntry[] {
  const result: DocPopupMenuFlatEntry[] = [];

  (items ?? []).forEach((item, index) => {
    if (item.visible === false) {
      return;
    }

    if (item.separator) {
      result.push({ kind: 'separator', id: `sep-${index}` });
      return;
    }

    if (item.items?.length) {
      if (item.label) {
        result.push({
          kind: 'header',
          id: `header-${index}`,
          label: item.label,
          subtitle: item.subtitle,
        });
      }
      result.push(...flattenDocPopupMenuItems(item.items));
      return;
    }

    result.push({ kind: 'item', id: `item-${index}-${item.label ?? ''}`, item });
  });

  return result;
}
